import { AxiosInstance, AxiosResponse } from "axios"

export interface TripDetailsResponseData {
  propertyName: string
  city: string
  state: string
  hostName: string
  coverImage: string
  hostReviews: number
  hostContactNo?: string
  hostEmailId?: string
  hostProfileUrl: string
  tripPaymentDetails: {
    hostFee?: number
    serviceFee?: number
    insuranceAmount?: number
    totalAmount?: number
    totalNight?: number
    totalNightlyPrice?: number
    totalTaxAmount?: number
    achSavedAmount?: number
    promoCodeAmount?: number
  }
}

export interface TripDetailsResponse extends AxiosResponse {
  data: {
    data: TripDetailsResponseData
  }
}

export function getTripDetailsApi(
  propertyId: string,
  axiosInstance: AxiosInstance,
): Promise<TripDetailsResponse> {
  return axiosInstance({
    method: "get",
    url: `/property/get-inquiry-trip-details?propertyId=${propertyId}`,
  }) as Promise<TripDetailsResponse>
}
